// Single source of truth for prerendering + sitemap generation.
// Consumed by scripts/prerender.mjs and scripts/generate-sitemap.mjs
// (imported via tsx or compiled — keep this file dependency-free).
export interface SeoRoute {
  path: string
}

export const SEO_ROUTES: SeoRoute[] = [
  { path: '/' },
  { path: '/listings' },
  { path: '/about' },
  { path: '/contact' },
  { path: '/areas' },
  { path: '/areas/lewes' },
  { path: '/areas/rehoboth-beach' },
  { path: '/areas/dewey-beach' },
  { path: '/areas/bethany-beach' },
  { path: '/areas/fenwick-island' },
  { path: '/areas/milton' },
  { path: '/sell' },
  { path: '/buy' },
  { path: '/faq' },
  { path: '/privacy' },
  { path: '/accessibility' },
  { path: '/sitemap' },
]

export const SITE_ORIGIN = 'https://debeachrealestate.com'
